/**
 * Company entity helpers for HR onboarding (Digital vs Systems).
 * Mirrors server/config/companyConfig.js for client UI + previews.
 */

export var COMPANY_DIGITAL = "Spanidea Digital Pvt. Ltd.";
export var COMPANY_SYSTEMS = "Spanidea Systems Pvt. Ltd.";

export var COMPANY_OPTIONS = [
  { value: COMPANY_DIGITAL, label: COMPANY_DIGITAL },
  { value: COMPANY_SYSTEMS, label: COMPANY_SYSTEMS },
];

var ADDRESS_SYSTEMS =
  "37/34/1, Statesman, 7th Floor, Green Glen Layout, Ibblur, Near Ibblur Lake, Outer Ring Road, Bengaluru, Karnataka - 560103";

var ADDRESS_DIGITAL =
  "B 7, Saraswati Nagar Basni 1 Jodhpur K.U.M. Bhagat Ki Kothi Jodhpur Rajasthan India 342005";

var ADDRESS_SYSTEMS_SHORT =
  "No. 37/34/1, Statesman, Green Glen Layout, Iblur Village, Outer Ring Road, Bengaluru- 560 103";

var ADDRESS_DIGITAL_SHORT =
  "B 7, Saraswati Nagar Basni 1, Jodhpur, Rajasthan, India 342005";

export function normalizeCompanyKey(companyName) {
  var text = companyName ? String(companyName).toLowerCase() : "";
  if (text.indexOf("digital") !== -1) {
    return "digital";
  }
  if (text.indexOf("systems") !== -1) {
    return "systems";
  }
  return "";
}

export function resolveCompanyName(companyName) {
  var key = normalizeCompanyKey(companyName);
  if (key === "digital") {
    return COMPANY_DIGITAL;
  }
  if (key === "systems") {
    return COMPANY_SYSTEMS;
  }
  return companyName ? String(companyName).trim() : COMPANY_DIGITAL;
}

export function resolveCompanyAddress(companyName, options) {
  var short = options && options.short;
  var key = normalizeCompanyKey(companyName);
  if (key === "digital") {
    return short ? ADDRESS_DIGITAL_SHORT : ADDRESS_DIGITAL;
  }
  if (key === "systems") {
    return short ? ADDRESS_SYSTEMS_SHORT : ADDRESS_SYSTEMS;
  }
  return short ? ADDRESS_DIGITAL_SHORT : ADDRESS_DIGITAL;
}

export function resolveCompanyDisplayLines(companyName) {
  return {
    name: resolveCompanyName(companyName),
    address: resolveCompanyAddress(companyName),
    addressShort: resolveCompanyAddress(companyName, { short: true }),
  };
}
